<template>
  <div class="animated fadeIn">
    <b-card >
      <div slot="header">AP Payment Plan 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Open</b-button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="(showFilter==1)">
        <b-col xl="7">
          <b-input-group >
            <b-input-group-prepend><span class="p-2">Create Date</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
              <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(createdate)="data">
          {{ data.item.createdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(totbayar)="data">
          {{data.item.totbayar|numFormat}}
        </template>
        <template v-slot:cell(totweek1)="data">
          {{data.item.totweek1|numFormat}}
        </template>
        <template v-slot:cell(totweek2)="data">
          {{data.item.totweek2|numFormat}}
        </template>
        <template v-slot:cell(totweek3)="data">
          {{data.item.totweek3|numFormat}}
        </template>
        <template v-slot:cell(totweek4)="data">
          {{data.item.totweek4|numFormat}}
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="rowEdit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-modal v-model="showForm" header-bg-variant="primary" size="md" title="New AP Payment Plan" :centered="true" @ok="save" ok-title="OK (Go Ahead)">
        <!-- <b-form @submit.stop.prevent="save"> -->
              <b-input-group>
                  <b-input-group-prepend ><label>Payment Period </label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.paym_sched" :state="!$v.frmdata.paym_sched.$error" type="date"></b-form-input>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend ><label>Expired Period </label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.expir_sched" :state="!$v.frmdata.expir_sched.$error" type="date"></b-form-input>
                  <!-- <b-form-input v-model="frmdata.paym_sched" :state="!$v.frmdata.paym_sched.$error" type="date"></b-form-input>
                  <b-form-input v-model="frmdata.expir_sched" :state="!$v.frmdata.expir_sched.$error" type="date" class="ml-1"></b-form-input> -->
              </b-input-group>
            <b-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend ><label>Local Currency </label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.matauang" :state="!$v.frmdata.matauang.$error" disabled ></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th >Exchange Rate Currency </th>
                  <th style="text-align:center">Into</th>
                  <th style="text-align:center">Rate</th>
                </tr>
              </thead>
              <tbody>
                  <tr v-for="(row,idx) in exchrate" :key="idx" >
                      <td style="text-align:center">{{row.valasfr}}</td>
                      <td> = {{row.valasto}}</td>
                      <td style="text-align:right; padding-left:5px;">            
                        <b-form-input v-model="row.nilaitukar" type="number" ></b-form-input>
                      </td>
                  </tr>
              </tbody>
            </table>

        <!-- </b-form> -->
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import appaymplan from "../../apis/appaymplan";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import dropdown from "../../data/dropdown";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        paym_sched: { required },
        expir_sched: { required },
        matauang: { required },
    },
  }, 
  data() {
    return {
      isLoading:false,
      showDelConfirm: false,
      showList:true,
      showForm:false,
      showFilter:true,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      currency:[],
      uanguser:this.$store.state.user.matauang,
      frmdata:{frmmode:'add', matauang: this.$store.state.user.matauang, paym_sched: '', expir_sched: ''},
      exchrate:[],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: moment().format('YYYY-MM-DD'),                
        sortBy: 'paym_sched',
        sortDesc: false
      },
      tblFields:[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
          },
        {
          key: "createdate",
          thStyle: "width:100px",
          label: "Create Date",
          sortable: true
        },
        {
          key: "createby",
          thStyle: "width:100px",
          label: "Create By",
          sortable: true
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "Rp,$,¥",
          sortable: true
        },
        {
          key: "totbayar",
          label: "Total Payment",
          sortable: true
        },
        {
          key: "totweek1",
          label: "Week#1 Payment",
          sortable: true
        },
        {
          key: "totweek2",
          label: "Week#2 Payment",
          sortable: true
        },
        {
          key: "totweek3",
          label: "Week#3 Payment",
          sortable: true
        },
        {
          key: "totweek4",
          label: "Week#4 Payment",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          thClass: "text-center",
        }          
      ],
      dataList: {
        YesNo: dropdown.YesNo,
        YesNoAll: dropdown.YesNoAll,
        BankOrCash: [{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
        BankOrCashAll: [{value: '', text: '-ALL-'},{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
      }      

    };
  },
  components: {Loading},
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function (){
     const currency = await appaymplan.currency(); 
     this.exchrate = currency.reduce( (newArr, item) => {
            if (item.value != this.uanguser) {
              newArr.push({valasfr:item.value , valasto: this.uanguser, nilaitukar:1});
            }
            return newArr;
     }, []);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await appaymplan.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh()
    },
    clearFilter(ctx) {
        this.tblData.tgl1= '';
        this.tblData.tgl2=  '';
        this.tblData.createby=  '';
        this.refresh();
    },
    rowEdit: function(data) {
        this.model=data;
        this.edit();
    },
    add: function(data) {
        // this.frmdata.matauang= this.uanguser;
        // this.frmdata.paym_sched= '';
        // this.frmdata.expir_sched= '';
      // this.frmdata.frmmode='add';
      this.showForm=true;
      this.showList=false;
    },
    edit: function(data) {
        if (this.model) {
              router.push({name :'treasury.appaymplanfrm', params: { payplankey: this.model.payplankey}});
        } else {
            toastr.warn('Please select a row that want to be Open/Edit!');
        }

    },
    save: async function (evt) {
        evt.preventDefault()
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              const row = {};
              for (var key in this.frmdata) {
                  row[key] = this.frmdata[key];
              }
              row.paym_sched = moment(this.frmdata.paym_sched).format('YYYY-MM-DD');
              row.expir_sched = moment(this.frmdata.expir_sched).format('YYYY-MM-DD');
              row.exchrate=this.exchrate;

              const hasil = await appaymplan.save(row);
              // this.closeFrm();              
              router.push({name :'treasury.appaymplanfrm', params: { payplankey: hasil.payplankey}});

              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    exportxls: async function() {
        if (this.model) {
            this.isLoading=true;
            try {
                const obj ={ payplankey: this.model.payplankey,
                  createdate : this.model.createdate ? moment(this.model.createdate).format('YYYY-MM-DD') : ''
                  }

                const response = await appaymplan.export(obj);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR',10000);
                }
            }
        } else {
            toastr.warn('Please select a row that want to be Export!');
        }
    },  

    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
        this.isLoading=true;
        try {
          await appaymplan.remove(this.model);
          this.refresh();
        this.isLoading=false;
        } catch (error) {
            this.isLoading=false;      
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }      
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
